import { render } from "./AdminBuilders.vue?vue&type=template&id=62f13248&scoped=true&ts=true&lang=pug"
import script from "./AdminBuilders.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminBuilders.vue?vue&type=script&lang=ts&setup=true"

import "./AdminBuilders.vue?vue&type=style&index=0&id=62f13248&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f13248"]])

export default __exports__